import Instance, { router } from './../main'
import { receiveLanguage } from './../services/TranslateHandler'
const env = require('./../../.environment')
const _ = require('lodash')

export default {
  /* Core */

  async setUser (context, user) {
    context.commit('setUser', user)
    if (user.profile_type === 10) {
      context.dispatch('checkCV')
    }
    await context.dispatch('receiveTranslate', context.getters.getLanguage).then(() => {
      context.dispatch('languageRedirect', context.getters.getLanguage)
    })
  },

  checkCV (context) {
    context.dispatch('jobseekerGetCvs', {page: 1, size: 1}).then(cvs => {
      context.commit('setUserHasCV', Boolean(cvs.items.length))
    })
  },

  languageRedirect (context, lang) {
    Instance.$router.replace({
      name: context.state.route.name,
      params: {
        0: context.state.route.params[0],
        lang: lang
      },
      query: context.state.route.query
    })
  },

  receiveSupportedLanguages () {
    return new Promise((resolve) => {
      router.app.$rpc.call('core.main.get_lang_info').then(res => {
        resolve(res.data.result.languages)
      }).catch(err => {
        throw err
      })
    })
  },

  receiveStaticPage (context, {url, lang}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('staticpages.main.get_static_page', {url: url, lang: lang}).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
        throw err
      })
    })
  },

  getHomeSlides () {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('common.slider.get_slides', {}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
        throw err
      })
    })
  },

  receivePageMetaByUrl (context, {url}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('staticpages.main.get_page_meta', {url: url}).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  receiveTranslate (context, lang) {
    return new Promise((resolve) => {
      receiveLanguage(lang).then(res => {
        resolve(res)
      })
    })
  },

  setCache (context, {name, value, lifeTime = 10}) {
    if (!context.state.cache[name]) {
      if (value.length || value) {
        setTimeout(() => {
          context.commit('removeCache', name)
        }, lifeTime * 1000 * 60)
        context.commit('setCache', {name: name, value: value})
      }
    }
  },

  dataFilter (context, {data, filters}) {
    let result = data
    filters = _.compact(filters)
    _.map(filters, (item) => {
      result = _.filter(result, {[item]: true})
    })
    return result
  },

  setLanguage (context, language) {
    context.commit('removeCache')
    context.commit('setLanguage', language)
    if (Instance.$auth.check()) {
      context.dispatch('setTranslate', {lang: language, tz: context.state.user.tz})
    }
  },

  uploadImage (context, {lang, img, profile, label, crop = null, progressHandler = {}}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('imgstorage.main.upload_image', {lang: lang, img_body: img, profile: profile, label: label, crop: crop}, progressHandler).then(res => {
        resolve(res.data.result.uploaded)
      }).catch(err => {
        reject(err)
      })
    })
  },

  uploadFile (context, {lang, document, profile, label, progressHandler = {}}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('docstorage.main.upload_document', {lang: lang, document_body: document, profile: profile, label: label}, progressHandler).then(res => {
        resolve(res.data.result.uploaded)
      }).catch(err => {
        reject(err)
      })
    })
  },

  /* Auth */

  jobseekerRegistration (context, {lang, data, hook}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('jobseekers.main.registration_by_email', {lang: lang, form_data: data, webapp_hook: hook}).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  jobseekerProfileUpdate (context, {lang, data}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('jobseekers.profile.update', {lang: lang, form_data: data}).then(res => {
        Instance.$auth.fetch()
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  employerRegistration (context, {lang, data, hook}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('employers.main.registration_by_email', {lang: lang, form_data: data, webapp_hook: hook}).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  employerProfileUpdate (context, {lang, data}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('employers.profile.update', {lang: lang, form_data: data}).then(res => {
        Instance.$auth.fetch()
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  login (context, {lang, email, password, rememberMe, agree, redirect = {name: 'Profile'}}) {
    return new Promise((resolve, reject) => {
      const data = {
        'jsonrpc': '2.0',
        'method': 'userauth.jwtauth.login_by_email',
        'params': {
          'lang': lang,
          'email': email,
          'password': password,
          'aud': 'webapp',
          'agree': agree
        },
        'id': Math.floor(Math.random() * 100)
      }
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/json-rpc' },
        data: data,
        url: env.RPC_ENDPOINT,
        rememberMe: rememberMe,
        fetchUser: true,
        redirect: redirect
      }
      Instance.$auth.login(options).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err.data.error)
      })
    })
  },

  logout (context, redirect = {name: 'Login'}) {
    return new Promise((resolve, reject) => {
      Instance.$auth.logout({redirect: redirect}).then((res) => {
        context.dispatch('setUser', {})
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  resetPassword (context, {lang, data, hook}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('userauth.jwtauth.reset_password_by_email', {lang: lang, form_data: data, webapp_hook: hook}).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  restoreAccount (context, {lang, data, hook}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('userauth.user.activate_user_account_by_email', {lang: lang, form_data: data, webapp_hook: hook}).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  getUserExportUrl (context, {lang}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('userauth.user.get_user_export_data_url', {lang}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  setNewPassword (context, {lang, data, token}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('userauth.jwtauth.set_new_password_by_reset_token', {lang: lang, form_data: data, token: token}).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  setTranslate (context, {lang, tz}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('userauth.user.set_i18n', {lang: lang, tz: tz}).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  changePassword (context, {lang, form}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('userauth.jwtauth.set_new_password_by_current', {lang: lang, form_data: form}).then(res => {
        Instance.$auth.fetch()
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  deactivateAccount (context, {lang, form}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('userauth.user.deactivate_account', {lang: lang, form_data: form}).then(res => {
        Instance.$auth.fetch()
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  socialLoginInfo () {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('userauth.social.get_login_info').then(res => {
        resolve(res.data.result.login_url)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  /* CVS */

  getCvPdf (context, {lang, cvID}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.cv.get_download_cv_pdf_url', {lang: lang, cv_id: cvID}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  getFavoriteCvs (context, {lang, pageNum, pageSize}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.favorites.get_favorites_cvs', {lang: lang, page_num: pageNum, page_size: pageSize}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  addCvTofavorites (context, {id}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.favorites.add_cv_to_favorites', {cv_id: id}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  deleteCvfromfavorites (context, {id}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.favorites.delete_cv_from_favorites', {cv_id: id}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  jobseekerCreateCV (context, {lang, data}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.cv.add_cv_for_current_user', {lang: lang, form_data: data}).then(res => {
        Instance.$auth.fetch()
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  jobseekerUpdateCV (context, {lang, data, id}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.cv.update_cv_of_current_user', {lang: lang, form_data: data, cv_id: id}).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  jobseekerDeleteCV (context, id) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.cv.delete_cv_of_current_user', {cv_id: id}).then(res => {
        // context.commit('setUserCV', {id: null, active: false})
        context.dispatch('checkCV')
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  jobseekerGetCvs (context, {page, size}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.cv.get_cvs_of_current_user', {page_num: page, page_size: size}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  jobseekerGetCV (context, id) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.cv.get_cv_for_edit_of_current_user', {cv_id: id}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  jobseekerActivateCV (context, {id, active}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.cv.update_activity_cv_of_current_user', {cv_id: id, is_active: active}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  sendCvToJoboffer (context, {lang, cv, offer, message = ''}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.cv.send_request_to_joboffer', {lang: lang, cv_ids: cv, job_offer_id: offer, message: message}).then(res => {
        if ((res.data.result || {}).success) resolve(res.data.result)
        else reject(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  receiveSenderCvs (context, {pageNum, pageSize, status}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.senders_cv.get_cvs', {page_num: pageNum, page_size: pageSize, status}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  addSenderCv (context, {lang, data}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.senders_cv.add_cv', {lang: lang, form_data: data}).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  receiveSenderCv (context, id) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.senders_cv.get_cv_for_edit', {cv_id: id}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  updateSenderCv (context, {lang, data, id}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.senders_cv.update_cv', {
        lang: lang,
        form_data: data,
        cv_id: id
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  deleteSenderCvs (context, {data}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.senders_cv.delete_cvs', {cv_ids: data}).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  updateSenderCvsActivity (context, {data, status}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.senders_cv.update_activity_cvs', {cv_ids: data, is_active: status}).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  getSenderStatuses (context, {lang}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('senders.statuses.get_statuses', {lang: lang}).then(res => {
        resolve(res.data.result.items)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  setSenderCvsStatus (context, {cvs, status}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('senders.statuses.change_cvs_status', {cv_ids: cvs, status_id: status}).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  /* Search */

  getPublicCV (context, {lang, id}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.cv.get_cv_public_detail', {lang: lang, cv_id: id}).then(res => {
        resolve((res.data.result || {}).cv || res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  getVacancy (context, {lang, id}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.main.get_job_offer_public_detail', {lang: lang, job_offer_id: id}).then(res => {
        resolve((res.data.result || {}).job_offer || res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  searchCV (context, {lang, q, page, size, order, filters}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('cvs.cv.search', {lang: lang, q: q, page_num: page, page_size: size, ordering: order, filters: filters}).then(res => {
        resolve(res.data.result || res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  searchVacancy (context, {lang, q, page, size, order, filters}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.main.search', {lang: lang, q: q, page_num: page, page_size: size, ordering: order, filters: filters}).then(res => {
        resolve(res.data.result || res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  /* Vacancies */

  addVacancyTofavorites (context, {id}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.favorites.add_job_offer_to_favorites', {job_offer_id: id}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  deleteVacancyFromfavorites (context, {id}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.favorites.delete_job_offer_from_favorites', {job_offer_id: id}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  getFavoriteVacancies (context, {lang, pageNum, pageSize}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.favorites.get_favorites_job_offers', {lang: lang, page_num: pageNum, page_size: pageSize}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  allowAddJobOffer (context) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.main.allow_to_add_job_offer').then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  employerCreateVacancy (context, {lang, data}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.main.add_job_offer_for_current_user', {lang: lang, form_data: data}).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  employerUpdateVacancy (context, {lang, data, id}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.main.update_job_offer_of_current_user', {lang: lang, form_data: data, job_offer_id: id}).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  employerDeleteVacancy (context, id) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.main.delete_job_offer_of_current_user', {job_offer_id: id}).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  employerGetVacancies (context, {page, size}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.main.get_job_offers_of_current_user', {page_num: page, page_size: size}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  employerGetVacancy (context, id) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.main.get_job_offer_for_edit_of_current_user', {job_offer_id: id}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  employerActivateVacancy (context, {id, active}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.main.update_activity_job_offer_of_current_user', {job_offer_id: id, is_active: active}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  receiveReceiverVacancies (context, {pageNum, pageSize, status}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.receiver_joboffer.get_joboffers', {page_num: pageNum, page_size: pageSize, status: status}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  addReceiverVacancy (context, {lang, data}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.receiver_joboffer.add_joboffer', {lang: lang, form_data: data}).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  receiveReceiverVacancy (context, id) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.receiver_joboffer.get_joboffer_for_edit', {job_offer_id: id}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  updateReceiverVacancy (context, {lang, data, id}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.receiver_joboffer.update_joboffer', {
        lang: lang,
        form_data: data,
        job_offer_id: id
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  deleteReceiverVacancies (context, {data}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.receiver_joboffer.delete_joboffers', {job_offer_ids: data}).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  updateReceiverVacanciesActivity (context, {data, status}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('joboffers.receiver_joboffer.update_activity_joboffers', {job_offer_ids: data, is_active: status}).then(res => {
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  getReceiverStatuses (context, {lang}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('receivers.statuses.get_statuses', {lang: lang}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  /* Dictionaries */

  receiveCurrencies (context, {lang}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('dictionaries.currency.get_currencies', {lang: lang}).then(res => {
        resolve(res.data.result.currency_types)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  receiveStayingTypes (context, {lang, id}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('dictionaries.stayingtype.get_staying_types', {lang: lang, country_id: id}).then(res => {
        resolve(res.data.result.staying_types)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  receiveCountries (context, {lang, filters = [], sortBy = 'name'}) {
    return new Promise((resolve) => {
      let result = context.state.cache['countries_' + filters.join('_')]
      if (result) {
        resolve(context.dispatch('dataFilter', {data: _.sortBy(result, sortBy), filters: filters}))
      } else {
        Instance.$rpc.call('geodata.main.get_countries', {lang: lang}).then(res => {
          let result = res.data.result.countries
          context.dispatch('setCache', {name: 'countries_' + filters.join('_'), value: result})
          filters = _.compact(filters)
          if (filters) {
            result = context.dispatch('dataFilter', {
              data: _.sortBy(result, sortBy),
              filters: filters
            })
            resolve(result)
          }
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveRegions (context, {lang, country, sortBy = 'name'}) {
    return new Promise((resolve) => {
      let result = context.state.cache['regions' + '_' + country]
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('geodata.main.get_regions_by_country', {lang: lang, country_iso2: country}).then(res => {
          let result = res.data.result.regions
          context.dispatch('setCache', {name: 'regions' + '_' + country, value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveCompanyTypes (context, {lang, country, sortBy = 'name', filters = []}) {
    return new Promise((resolve) => {
      let result = context.state.cache['company_types' + '_' + country]
      if (result) {
        resolve(context.dispatch('dataFilter', {data: _.sortBy(result, sortBy), filters: filters}))
      } else {
        Instance.$rpc.call('dictionaries.companytype.get_company_types', {lang: lang, country_id: country}).then(res => {
          let result = res.data.result.company_types
          context.dispatch('setCache', {name: 'company_types' + '_' + country, value: result})
          filters = _.compact(filters)
          if (filters) {
            result = context.dispatch('dataFilter', {
              data: _.sortBy(result, sortBy),
              filters: filters
            })
            resolve(result)
          }
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveCvsForJobOffers (context, {lang, jobOfferId, pageNum, pageSize}) {
    return new Promise(resolve => {
      Instance.$rpc.call('joboffers.sentcvtojoboffer.get_cvs_for_joboffer', {
        lang: lang,
        joboffer_id: jobOfferId,
        page_num: pageNum,
        page_size: pageSize
      }).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        throw err
      })
    })
  },

  markAsActiveCvForJobOffer (context, {cvId, jobOfferId}) {
    return new Promise(resolve => {
      Instance.$rpc.call('joboffers.sentcvtojoboffer.mark_as_read', {
        cv_id: cvId,
        joboffer_id: jobOfferId
      }).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        throw err
      })
    })
  },

  getCompanyType (context, {lang, country, id}) {
    return new Promise((resolve) => {
      let companyTypes = context.state.cache.company_types
      if (companyTypes) {
        resolve(_.find(companyTypes, {'id': id}))
      } else {
        context.dispatch('receiveCompanyTypes', {lang: lang, country: country}).then(res => {
          resolve(_.find(res, {'id': id}))
        })
      }
    }).catch(err => {
      throw err
    })
  },

  getCountry (context, {lang, id}) {
    return new Promise(resolve => {
      let countries = context.state.cache.countries
      if (countries) {
        resolve(_.find(countries, {'id': id}))
      } else {
        context.dispatch('receiveCountries', {lang: lang}).then(res => {
          resolve(_.find(res, {'id': id}))
        })
      }
    }).catch(err => {
      throw err
    })
  },

  receiveCompanySectors (context, {lang, type, sortBy = 'name'}) {
    return new Promise((resolve) => {
      let result = context.state.cache['company_sectors' + '_' + type]
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.companysector.get_company_sectors', {lang: lang, companytype_id: type}).then(res => {
          let result = res.data.result.company_sectors
          context.dispatch('setCache', {name: 'company_sectors' + '_' + type, value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveWorkResponsibility (context, {lang, sector, sortBy = 'name'}) {
    return new Promise((resolve) => {
      let result = context.state.cache['work_responsibilities' + '_' + sector]
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.workresponsibility.get_work_responsibilities', {lang: lang, companysector_id: sector}).then(res => {
          let result = res.data.result.work_responsibilities
          context.dispatch('setCache', {name: 'work_responsibilities' + '_' + sector, value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveNationalities (context, {lang, sortBy = 'name'}) {
    return new Promise((resolve) => {
      let result = context.state.cache.nationalities
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.nationality.get_nationalities', {lang: lang}).then(res => {
          let result = res.data.result.nationalities
          context.dispatch('setCache', {name: 'nationalities', value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveEducationTypes (context, {lang, sortBy = 'id'}) {
    return new Promise((resolve) => {
      let result = context.state.cache.education_types
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.educationtype.get_education_types', {lang: lang}).then(res => {
          let result = res.data.result.education_types
          context.dispatch('setCache', {name: 'education_types', value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveMainSpeakingLanguages (context, {lang, sortBy = 'id'}) {
    return new Promise((resolve) => {
      let result = context.state.cache.main_speaking_languages
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.speakinglanguage.get_main_speaking_languages', {lang: lang}).then(res => {
          let result = res.data.result.speaking_languages
          context.dispatch('setCache', {name: 'main_speaking_languages', value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveSpeakingLanguages (context, {lang, sortBy = 'id'}) {
    return new Promise((resolve, reject) => {
      let result = context.state.cache.speaking_languages
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.speakinglanguage.get_speaking_languages', {lang: lang}).then(res => {
          let result = res.data.result.speaking_languages
          context.dispatch('setCache', {name: 'speaking_languages', value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          reject(err)
        })
      }
    })
  },

  receiveSpeakingLanguageLevels (context, {lang, sortBy = 'id'}) {
    return new Promise((resolve) => {
      let result = context.state.cache.speaking_lang_levels
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.speakinglanglevel.get_speaking_lang_levels', {lang: lang}).then(res => {
          let result = res.data.result.speaking_lang_levels
          context.dispatch('setCache', {name: 'speaking_lang_levels', value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveDrivingLicences (context, {lang, sortBy = 'id'}) {
    return new Promise((resolve) => {
      let result = context.state.cache.driving_licences
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.drivinglicence.get_driving_licences', {lang: lang}).then(res => {
          let result = res.data.result.driving_licences
          context.dispatch('setCache', {name: 'driving_licences', value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveEmploymentTypes (context, {lang, sortBy = 'id'}) {
    return new Promise((resolve) => {
      let result = context.state.cache.employment_types
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.employmenttype.get_employment_types', {lang: lang}).then(res => {
          let result = res.data.result.employment_types
          context.dispatch('setCache', {name: 'employment_types', value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveBodyHeightRanges (context, {lang, sortBy = 'id'}) {
    return new Promise((resolve) => {
      let result = context.state.cache.body_height_ranges
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.bodyheightrange.get_body_height_ranges', {lang: lang}).then(res => {
          let result = res.data.result.body_height_ranges
          context.dispatch('setCache', {name: 'body_height_ranges', value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveExperienceTimeRanges (context, {lang, sortBy = 'id'}) {
    return new Promise((resolve) => {
      let result = context.state.cache.experience_time_ranges
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.experiencetimerange.get_experience_time_ranges', {lang: lang}).then(res => {
          let result = res.data.result.experience_time_ranges
          context.dispatch('setCache', {name: 'experience_time_ranges', value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveMaritalStatuses (context, {lang, sortBy = 'id'}) {
    return new Promise(resolve => {
      Instance.$rpc.call('dictionaries.maritalstatus.get_marital_statuses', {lang: lang}).then(res => {
        let result = res.data.result.marital_statuses
        context.dispatch('setCache', {name: 'marital_statuses', value: result})
        resolve(_.sortBy(result, sortBy))
      }).catch(err => {
        throw err
      })
    })
  },

  receiveAgeRangeFilterItems (context, {lang, type, sortBy = 'id'}) {
    return new Promise(resolve => {
      let result = context.state.cache['age_range_filter_items' + '_' + type]
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.agerangefilteritem.get_age_range_filter_items', { lang: lang, context: type }).then(res => {
          let result = res.data.result.age_range_filter_items
          context.dispatch('setCache', {name: 'age_range_filter_items' + '_' + type, value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveBodyHeightRangeFilterItems (context, {lang, type, sortBy = 'id'}) {
    return new Promise(resolve => {
      let result = context.state.cache['body_height_range_filter_items' + '_' + type]
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.bodyheightrangefilteritem.get_body_height_range_filter_items', { lang: lang, context: type }).then(res => {
          let result = res.data.result.body_height_range_filter_items
          context.dispatch('setCache', {name: 'body_height_range_filter_items' + '_' + type, value: result})
          resolve(result)
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveBodyWeightRangeFilterItems (context, {lang, type, sortBy = 'id'}) {
    return new Promise(resolve => {
      let result = context.state.cache['body_weight_range_filter_items' + '_' + type]
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.bodyweightrangefilteritem.get_body_weight_range_filter_items', { lang: lang, context: type }).then(res => {
          let result = res.data.result.body_weight_range_filter_items
          context.dispatch('setCache', {name: 'body_weight_range_filter_items' + '_' + type, value: result})
          resolve(result)
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveExperienceTimeRangeFilterItems (context, {lang, type, sortBy = 'id'}) {
    return new Promise(resolve => {
      let result = context.state.cache['experience_time_range_filter_items' + '_' + type]
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.experiencetimerangefilteritem.get_experience_time_range_filter_items', {
          lang: lang,
          context: type
        }).then(res => {
          let result = res.data.result.experience_time_range_filter_items
          context.dispatch('setCache', {name: 'experience_time_range_filter_items' + '_' + type, value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveEducationStatuses (context, lang, sortBy = 'id') {
    return new Promise(resolve => {
      let result = context.state.cache.education_statuses
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.educationstatus.get_education_statuses', {lang: lang}).then(res => {
          let result = res.data.result.education_statuses
          context.dispatch('setCache', {name: 'education_statuses', value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          throw err
        })
      }
    })
  },

  receiveWorkProfessions (context, {lang, sector, sortBy = 'name'}) {
    return new Promise((resolve, reject) => {
      let result = context.state.cache[`work_professions_${sector}`]
      if (result) {
        resolve(_.sortBy(result, sortBy))
      } else {
        Instance.$rpc.call('dictionaries.workprofession.get_work_professions', {lang: lang, companysector_id: sector}).then(res => {
          let result = res.data.result.work_professions
          context.dispatch('setCache', {name: `work_professions_${sector}`, value: result})
          resolve(_.sortBy(result, sortBy))
        }).catch(err => {
          reject(err)
        })
      }
    })
  },

  /* Finance */

  getFinanceAccountDetail (context, lang) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('finance.account.get_finance_account_of_current_user', {lang: lang}).then(res => {
        resolve((res.data.result || {}).finance_account || res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  getAmountChangeLog (context, {lang, account, page, size}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('finance.account.get_amount_change_log_items', {lang: lang, finance_account_id: account, page_num: page, page_size: size}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  /* Services */

  receiveServicesPricesForCountries (context, {lang, employerCountryId, jobseekerCountryId, service}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call(`services.${service}.get_prices_for_countries`, {
        lang: lang,
        employer_country_id: employerCountryId,
        jobseeker_country_id: jobseekerCountryId
      }).then(res => {
        resolve((res.data.result || {}).items || res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  receiveServicesEmployerCountries (context, {service}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call(`services.${service}.get_employer_countries`).then(res => {
        resolve((res.data.result || {}).items || res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  receiveServicesJobSeekerCountries (context, {employerCountryId, service}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call(`services.${service}.get_jobseeker_countries`, {
        employer_country_id: employerCountryId
      }).then(res => {
        resolve((res.data.result || {}).items || res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  getCvServiceItems (context, lang) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('services.packages.get_cvcontactsaccess_items', {lang: lang}).then(res => {
        resolve((res.data.result || {}).items || res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  sendServiceForm (context, {lang, data}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('feedbacks.simpleservice.submit', {lang: lang, form_data: data}).then(res => {
        resolve((res.data.result || {}).items || res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  receiveFeedbacks (context, {lang, pageNum, pageSize}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('feedbacks.comment.get_all_comments', {lang: lang, page_num: pageNum, page_size: pageSize}).then(res => {
        resolve((res.data.result || {}).items || res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  sendCvsContactsNonAuth (context, {lang, form_data: {text, name, phoneNumber, email, agree}}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('feedbacks.contactus.add_contact_us_not_auth_user', {
        lang: lang,
        form_data: {
          text,
          name,
          phone_number: phoneNumber,
          email,
          agree
        }
      }).then(res => {
        resolve((res.data.result || {}).items || res.data.result)
      })
    })
  },

  sendCvsContactsAuth (context, {lang, form_data: {text}}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('feedbacks.contactus.add_contact_us_auth_user', {
        lang: lang,
        form_data: {
          text
        }
      }).then(res => {
        resolve((res.data.result || {}).items || res.data.result)
      })
    })
  },

  sendQuickTraineeship (context, {lang, form_data: {firstName, lastName, phoneNumber, email, nationality, age}}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('feedbacks.quicktraineeshipregistration.submit', {
        lang: lang,
        form_data: {
          first_name: firstName,
          last_name: lastName,
          phone_number: phoneNumber,
          nationality: nationality,
          email: email,
          age: age
        }
      }).then(res => {
        resolve((res.data.result || {}).items || res.data.result)
      })
    })
  },

  sendCvsRequestNonAuth (context, {lang, form_data: {text, name, phoneNumber, email, agree, cv}}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('feedbacks.requestcv.add_request_cv_not_auth_user', {
        lang: lang,
        form_data: {
          text,
          name,
          phone_number: phoneNumber,
          email,
          agree,
          cv
        }
      }).then(res => {
        resolve((res.data.result || {}).items || res.data.result)
      })
    })
  },

  sendCvsRequestAuth (context, {lang, form_data: {text, cv}}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('feedbacks.requestcv.add_request_cv_auth_user', {
        lang: lang,
        form_data: {
          text,
          cv
        }
      }).then(res => {
        resolve((res.data.result || {}).items || res.data.result)
      })
    })
  },

  /* Billing */

  getBillingProvidedServices (context, {lang, account, archive, pageNum, pageSize}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('billing.provided_service.get_list', {lang: lang, finance_account_id: account, archive: archive, page_num: pageNum, page_size: pageSize}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  getBillingInvoices (context, {lang, account, page, size}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('billing.invoice.get_list', {lang: lang, finance_account_id: account, page_num: page, page_size: size}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  getBillingInvoiceDetail (context, {lang, invoice}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('billing.invoice.get_detail', {lang: lang, invoice_id: invoice}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  createInvoice (context, {lang, account, service, type}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('billing.invoice.create_with_single_item', {lang: lang, finance_account_id: account, service_id: service, service_type: type}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  createInvoiceTopUp (context, {lang, account, amount}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('billing.invoice.create_top_up', {lang: lang, finance_account_id: account, amount: amount}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  cancelInvoice (context, {lang, invoice}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('billing.invoice.cancel', {lang: lang, invoice_id: invoice}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  hitContactAccess (context, {account, cv}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('billing.service.cvcontacts_access_hit', {finance_account_id: account, cv_id: cv}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  /* Payments */

  getPayMethods (context, {lang, account, invoice}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('payments.main.get_available_paymethods', {lang: lang, finance_account_id: account, invoice_id: invoice}).then(res => {
        resolve((res.data.result || {}).items || res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  validatePayment (context, {lang, account, invoice, paymethod, amount = null, extra = null}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('payments.main.validate_payment', {
        lang: lang,
        finance_account_id: account,
        invoice_id: invoice,
        paymethod: paymethod,
        extra: extra,
        amount: amount}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  registerPayment (context, payment) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('payments.main.register_payment', {signed_payment_data: payment}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject(err)
      })
    })
  },

  senderRegistration (context, {lang, data, hook}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('senders.main.registration_by_email', {lang: lang, form_data: data, webapp_hook: hook}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  senderProfileUpdate (context, {lang, data}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('senders.profile.update', {lang: lang, form_data: data}).then(res => {
        Instance.$auth.fetch()
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  receiverRegistration (context, {lang, data, hook}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('receivers.main.registration_by_email', {lang: lang, form_data: data, webapp_hook: hook}).then(res => {
        resolve(res.data.result)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  },

  receiverProfileUpdate (context, {lang, data}) {
    return new Promise((resolve, reject) => {
      Instance.$rpc.call('receivers.profile.update', {lang: lang, form_data: data}).then(res => {
        Instance.$auth.fetch()
        resolve(res)
      }).catch(err => {
        reject((err.data || {}).error || err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js